export default __webpack_public_path__ + "static/media/s-43.f15114f0.svg";